import * as React from 'react';
import { Icon } from '@leagueplatform/genesis-core';
import {
  AccordionSingleItem,
  NumberIcon,
  ArrayActionButtons,
} from '@web-config-app/entity-form';
import type { PrimitiveObjectArrayItemProps } from '@web-config-app/entity-form';

export const PrimitiveObjectArrayItem = ({
  uniqueId,
  children,
  itemLabel,
  itemNumber,
  itemData,
  path,
  handleOnMoveDown,
  handleOnMoveUp,
  handleRemoveItem,
  handleDuplicateItem,
  index,
  enabled,
  arrayLength,
  hasError = false,
  onMoveToPosition,
  dragHandleProps,
}: React.PropsWithChildren<PrimitiveObjectArrayItemProps>) => (
  <AccordionSingleItem
    id={uniqueId}
    headingLevel="display"
    accordionHeading={
      <>
        <NumberIcon number={itemNumber} css={{ margin: 'auto $half' }} />
        {itemLabel}
        {hasError ? (
          <Icon
            icon="statusErrorStatusFilled"
            css={{ marginInline: '$half' }}
            size="$one"
            tint="$criticalIcon"
          />
        ) : null}
      </>
    }
    additionalActions={
      <ArrayActionButtons
        showDeleteModal
        onDuplicate={handleDuplicateItem(itemData, index)}
        onDelete={handleRemoveItem(path, index)}
        onMoveDown={dragHandleProps ? undefined : handleOnMoveDown(path, index)}
        onMoveUp={dragHandleProps ? undefined : handleOnMoveUp(path, index)}
        onMoveToPosition={dragHandleProps ? undefined : onMoveToPosition}
        itemLabel={itemLabel as string}
        itemIndex={index}
        arrayLength={arrayLength}
        disableAllActions={enabled === false}
        dragHandleProps={dragHandleProps}
      />
    }
  >
    {children}
  </AccordionSingleItem>
);
